import React from "react";
const InfoList = (props) => {
  const className = props.className ?? ''
  return (
    <div className="info-value">
      <div className="left">{props.left}</div>
      <div className={"right "+ className}>{props.right}</div>
    </div>
  );
};
export default InfoList;
